module.exports = __webpack_public_path__ + "static/media/different-equation-box-bg.9e274202.avif";